import PieChart from "components/charts/PieChart";
import Card from "components/card";
import { BiMessageAltError } from "react-icons/bi";

const PieChartCard = ({ complaint_data }) => {
  const pieChartOptions = {
    labels: [
      "Active Complaints",
      "Pending Complaints",
      "Closed Complaints",
      "Inactive Complaints",
    ],
    colors: ["#00C49A", "#FFB84D", "#6A5ACD", "#FF6F61"],
    chart: {
      width: "50px",
    },
    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
    },
    legend: {
      show: true,
      position: "bottom", // You can also use 'top', 'right', 'left'
      fontSize: "14px",
      fontFamily: "Helvetica, Arial",
      labels: {
        colors: ["#A4AFD1"], // Adjust color for text if needed
        weight: "bold",
      },
      markers: {
        width: 12,
        height: 12,
        radius: 12,
      },
    },
    dataLabels: {
      enabled: false,
    },
    hover: { mode: null },
    plotOptions: {
      pie: {
        expandOnClick: false,
        labels: {
          show: false,
        },
      },
    },
    fill: {
      colors: ["#00C49A", "#FFB84D", "#6A5ACD", "#FF6F61"],
    },
    tooltip: {
      enabled: true,
      theme: "dark",
      style: {
        fontSize: "12px",
        backgroundColor: "#000000",
      },
    },
  };

  const pieChartData = [
    complaint_data?.active_complaints || 0,
    complaint_data?.hold_complaints || 0,
    complaint_data?.resolved_complaints || 0,
    complaint_data?.inactive_complaints || 0,
  ];

  return (
    <Card extra="rounded-[20px] p-3">
      <div className="flex flex-row justify-between px-3 py-2">
        <div>
          <h4 className="text-lg font-bold text-navy-700 dark:text-white">
            Complaints Analysis
          </h4>
        </div>
      </div>

      <div className="mb-auto flex h-[350px] w-full items-center justify-center">
        {complaint_data ? (
          <PieChart options={pieChartOptions} series={pieChartData} />
        ) : (
          <div className="flex flex-col items-center justify-center">
            <BiMessageAltError size={40} className="text-gray-500" />
            <p className="text-xl font-semibold text-gray-500">No Data Found</p>
          </div>
        )}
      </div>

      {/* Legend can be shown automatically with the chart now */}

      {/* <div className="flex flex-row !justify-between rounded-2xl px-6 py-0 pb-2 shadow-2xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center justify-center">
            <div className="h-2 w-2 rounded-full bg-brand-500" />
            <p className="ml-1 text-sm font-normal text-gray-600">
              Total Complaints
            </p>
          </div>
          <p className="mt-px text-xl font-bold text-navy-700  dark:text-white">
            {complaint_data?.all_registered_complaints}
          </p>
        </div>

        <div className="h-11 w-px bg-gray-300 dark:bg-white/10" />

        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center justify-center">
            <div className="h-2 w-2 rounded-full bg-[#3311DB]" />
            <p className="ml-1 text-sm font-normal text-gray-600">
              Closed Complaints
            </p>
          </div>
          <p className="mt-px text-xl font-bold text-navy-700 dark:text-white">
            {complaint_data?.resolved_complaints}
          </p>
        </div>
      </div> */}
    </Card>
  );
};

export default PieChartCard;
